import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import _ from 'lodash';
import { salesAttributeDataParser } from 'parser/salesAttributionDataParser';
import { salesTrendChartParser } from 'parser/priceCurveParser';
import { priceCurveTrendsChart } from 'gqlQueries/priceCurve';

const errorMessage: string = 'Something went wrong!';

const dummyData = {
    getAttributeTrendChartData: {
        data: [
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '07-18-22',
                periodLabel: '2022W30',
                attributionValue: 0,
                salesCurrent: 42948,
                salesPrevious: 55484,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '07-25-22',
                periodLabel: '2022W31',
                attributionValue: 0,
                salesCurrent: 54148,
                salesPrevious: 32792,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '08-01-22',
                periodLabel: '2022W32',
                attributionValue: 0,
                salesCurrent: 41812,
                salesPrevious: 46516,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '08-08-22',
                periodLabel: '2022W33',
                attributionValue: 0,
                salesCurrent: 29536,
                salesPrevious: 60156,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '08-15-22',
                periodLabel: '2022W34',
                attributionValue: 0,
                salesCurrent: 30508,
                salesPrevious: 51224,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '08-22-22',
                periodLabel: '2022W35',
                attributionValue: 0,
                salesCurrent: 30308,
                salesPrevious: 41324,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '08-29-22',
                periodLabel: '2022W36',
                attributionValue: 0,
                salesCurrent: 30092,
                salesPrevious: 40120,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '09-05-22',
                periodLabel: '2022W37',
                attributionValue: 0,
                salesCurrent: 35640,
                salesPrevious: 37524,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '09-12-22',
                periodLabel: '2022W38',
                attributionValue: 0,
                salesCurrent: 42796,
                salesPrevious: 42504,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '09-19-22',
                periodLabel: '2022W39',
                attributionValue: 0,
                salesCurrent: 34796,
                salesPrevious: 39832,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '09-26-22',
                periodLabel: '2022W40',
                attributionValue: 0,
                salesCurrent: 28364,
                salesPrevious: 37224,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '10-03-22',
                periodLabel: '2022W41',
                attributionValue: 0,
                salesCurrent: 29872,
                salesPrevious: 37476,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '10-10-22',
                periodLabel: '2022W42',
                attributionValue: 0,
                salesCurrent: 5744,
                salesPrevious: 48612,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '10-17-22',
                periodLabel: '2022W43',
                attributionValue: 0,
                salesCurrent: 9356,
                salesPrevious: 56008,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '10-24-22',
                periodLabel: '2022W44',
                attributionValue: 0,
                salesCurrent: 12776,
                salesPrevious: 52436,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '10-31-22',
                periodLabel: '2022W45',
                attributionValue: 0,
                salesCurrent: 8712,
                salesPrevious: 47712,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '11-07-22',
                periodLabel: '2022W46',
                attributionValue: 0,
                salesCurrent: 5140,
                salesPrevious: 37100,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '11-14-22',
                periodLabel: '2022W47',
                attributionValue: 0,
                salesCurrent: 6264,
                salesPrevious: 27876,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '11-21-22',
                periodLabel: '2022W48',
                attributionValue: 0,
                salesCurrent: 5788,
                salesPrevious: 19412,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '11-28-22',
                periodLabel: '2022W49',
                attributionValue: 0,
                salesCurrent: 15972,
                salesPrevious: 29388,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '12-05-22',
                periodLabel: '2022W50',
                attributionValue: 0,
                salesCurrent: 33808,
                salesPrevious: 32112,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '12-12-22',
                periodLabel: '2022W51',
                attributionValue: 0,
                salesCurrent: 11496,
                salesPrevious: 28180,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '12-19-22',
                periodLabel: '2022W52',
                attributionValue: 0,
                salesCurrent: 3936,
                salesPrevious: 20324,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '12-26-22',
                periodLabel: '2022W53',
                attributionValue: -1368,
                salesCurrent: 3564,
                salesPrevious: 23488,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '01-02-23',
                periodLabel: '2023W01',
                attributionValue: -35252,
                salesCurrent: 1388,
                salesPrevious: 52772,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '01-09-23',
                periodLabel: '2023W02',
                attributionValue: -60384,
                salesCurrent: 2640,
                salesPrevious: 73988,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '01-16-23',
                periodLabel: '2023W03',
                attributionValue: -60420,
                salesCurrent: 340,
                salesPrevious: 64924,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '01-23-23',
                periodLabel: '2023W04',
                attributionValue: -57496,
                salesCurrent: 108,
                salesPrevious: 62044,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '01-30-23',
                periodLabel: '2023W05',
                attributionValue: -44204,
                salesCurrent: 92,
                salesPrevious: 49816,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '02-06-23',
                periodLabel: '2023W06',
                attributionValue: -23540,
                salesCurrent: 60,
                salesPrevious: 27068,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '02-13-23',
                periodLabel: '2023W07',
                attributionValue: -19880,
                salesCurrent: 16,
                salesPrevious: 22768,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '02-20-23',
                periodLabel: '2023W08',
                attributionValue: -21032,
                salesCurrent: 128,
                salesPrevious: 24596,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '02-27-23',
                periodLabel: '2023W09',
                attributionValue: -31048,
                salesCurrent: 100,
                salesPrevious: 38768,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '03-06-23',
                periodLabel: '2023W10',
                attributionValue: -42712,
                salesCurrent: 32,
                salesPrevious: 54468,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '03-13-23',
                periodLabel: '2023W11',
                attributionValue: -33119.8,
                salesCurrent: 12.2,
                salesPrevious: 40860,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '03-20-23',
                periodLabel: '2023W12',
                attributionValue: -25756,
                salesCurrent: 40,
                salesPrevious: 30676,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '03-27-23',
                periodLabel: '2023W13',
                attributionValue: -25116,
                salesCurrent: 12,
                salesPrevious: 29756,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '04-10-23',
                periodLabel: '2023W15',
                attributionValue: -24856,
                salesCurrent: 40,
                salesPrevious: 31864,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '04-17-23',
                periodLabel: '2023W16',
                attributionValue: -20996,
                salesCurrent: 8,
                salesPrevious: 26932,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '04-24-23',
                periodLabel: '2023W17',
                attributionValue: -24412,
                salesCurrent: 8,
                salesPrevious: 31296,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '05-15-23',
                periodLabel: '2023W20',
                attributionValue: -24272,
                salesCurrent: 4,
                salesPrevious: 30880,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '05-22-23',
                periodLabel: '2023W21',
                attributionValue: -22000,
                salesCurrent: 8,
                salesPrevious: 30132,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '05-29-23',
                periodLabel: '2023W22',
                attributionValue: -21608,
                salesCurrent: 4,
                salesPrevious: 29508,
                __typename: 'SalesAttributionWeekLvlData',
            },
            {
                attributeName: 'KIND NUT BUTTER FILLED 4',
                startTimestamp: '06-05-23',
                periodLabel: '2023W23',
                attributionValue: -3604,
                salesCurrent: 4,
                salesPrevious: 31108,
                __typename: 'SalesAttributionWeekLvlData',
            },
        ],
        meta: {
            count: 44,
            __typename: 'AttributeTotalSalesMeta',
        },
        __typename: 'SalesAttributionWeekLvl',
    },
};

function useFetchTrendsChart() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);

    const { appConfig } = useContext(UserContext);

    const [
        fetchTrendsChartData,
        { data: salesTrendChartData, loading: salesTrendChartDataLoading, error: salesTrendChartDataError },
    ] = useLazyQuery(priceCurveTrendsChart, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPriceCurveTrendChartData: getAttributeTrendChartData } = payload;
            //const featureGroup = payload;
            //if data present parse it
            if (getAttributeTrendChartData && 'data' in getAttributeTrendChartData) {
                const parsedData = salesTrendChartParser(getAttributeTrendChartData?.data, appConfig);
                setData({ chartData: parsedData });
                return;
            }

            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        setLoading,
        fetchTrendsChartData: (variables: any) => {
            setData(null);
            setLoading(true);
            setError(null);
            //onFetchComplete(dummyData);
            fetchTrendsChartData(variables);
        },
    };
}

export { useFetchTrendsChart };
